$(document).ready(function () {
  $(".search-desktop").submit(function () {
    $(".search__results-desktop")
      .load("/ajax/new-searchajax", $(".search-desktop").serialize())
      .show();
    return false;
  });

  $(".search-desktop .search__input").keyup(function () {
    if (this.value.length > 2) {
      $(".search__results-desktop")
        .load("/ajax/new-searchajax", $(".search-desktop").serialize())
        .show();
    } else {
      $(".search__results-desktop").hide();
    }
  });

  $(".search__input").focus(function () {
    $("body").addClass("search__focus");
    $(this).parents().find(".search-bar").addClass("search-bar-focus");
  });

  $(".search__close").on("click", function () {
    $("body").removeClass("search__focus");
    $(".search-bar").removeClass("search-bar-focus");
    $(".search__results").slideUp();
  });
});
